@import "~@govbr-ds/core/src/components/checkbox/checkbox";
@import "~@govbr-ds/core/src/components/input/input";
@import "~@govbr-ds/core/src/components/tag/tag";

:host {
  display: inline-block;
  margin-right: var(--spacing-scale-half);

  .tag-spacing-status {
    margin-left: var(--spacing-scale-half);
  }

  .br-tag {
    &.interaction {
      br-button {
        margin-left: var(--spacing-scale-baseh);
      }
    }

    &:not(.icon) {
      br-icon {
        margin-right: var(--spacing-scale-base);
      }
    }
  }
}
